interface ToastProps {
  message: string | null;
}

export default function Toast({ message }: ToastProps) {
  if (!message) return null;
  return (
    <div className="pointer-events-none fixed bottom-8 left-1/2 z-[100] -translate-x-1/2 animate-fade-up">
      <div className="flex items-center gap-2 rounded-full bg-foreground-950 px-5 py-3 text-sm text-background-50 shadow-lg">
        <i className="ri-information-line text-base text-primary-300"></i>
        {message}
      </div>
    </div>
  );
}